import Image from 'next/image'
import clsx from 'clsx'

/* styles */
import styles from './_.module.css'

function PepperGPTComparison() {
  return (
    <section className="font-heading text-white bg-blue-web-90">
      <div className="container | py-10 md:py-18">
        <h3 className="text-3xl md:text-5xl font-semibold | mb-10 md:mb-28">
          Beyond the ordinary AI
        </h3>

        <div className={clsx('w-full overflow-x-auto pb-12', styles.scrollbar)}>
          <table className="min-w-full">
            <thead className="border-b-2 border-[#0C0080]">
              <tr>
                <th className="text-base md:text-2xl text-left font-semibold whitespace-nowrap | sticky top-0 left-0 overflow-y-hidden bg-blue-web-90 z-10 pl-7 pr-14 md:pl-24 md:pr-44 py-5">
                  Key Benefits
                </th>
                <th className="text-base md:text-2xl text-yellow-50 text-left font-semibold whitespace-nowrap | sticky top-0 px-6 py-5">
                  Pepper Content
                </th>
                <th className="text-base md:text-2xl text-cyan-70 text-center md:text-right font-semibold md:whitespace-nowrap | px-6 py-5">
                  Other GPT-4 providers
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((item, index) => (
                <tr
                  key={item.title}
                  className={clsx(index % 2 === 0 ? '' : 'bg-[#0A0066]')}
                >
                  <td
                    className={clsx(
                      'font-body text-small md:text-lg text-gray-20 | sticky top-0 left-0 overflow-y-hidden pl-7 pr-5 md:pl-24 md:pr-44 py-4',
                      index % 2 === 0 ? 'bg-blue-web-90' : 'bg-[#0A0066]'
                    )}
                  >
                    {item.title}
                  </td>
                  <td className="px-6 py-4">
                    <Image
                      src="/assets/icons/comparison-tick.svg"
                      alt=""
                      width={36}
                      height={36}
                      className="w-5 h-5 md:w-9 md:h-9 mx-auto"
                    />
                  </td>
                  <td className="px-6 py-4">
                    <Image
                      src="/assets/icons/comparison-cross.svg"
                      alt=""
                      width={36}
                      height={36}
                      className="w-5 h-5 md:w-9 md:h-9 mx-auto"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

const tableData = [
  {
    title: 'Your brand, your voice'
  },
  {
    title: 'No hallucinations, just factual content'
  },
  {
    title: 'Smarter AI, improved by millions of marketers across the globe'
  },
  {
    title: 'Scaling at warp speed'
  },
  {
    title: 'Robust editor layer, powered by humans'
  },
  {
    title: 'Privacy and data protection'
  },
  {
    title: 'Easy plug-and-play with the tools you love'
  },
  {
    title: 'End-to-end content control and visibility'
  },
  {
    title: 'Collaborative platform'
  }
]

export default PepperGPTComparison
